// extracted by mini-css-extract-plugin
export default {"container":"jobs_container__OCwHK","divider":"jobs_divider__qoqro","tab_container":"jobs_tab_container__KPRWf"};